import { render, staticRenderFns } from "./MapaCalorNovedades.vue?vue&type=template&id=b1ebde18&scoped=true"
import script from "./MapaCalorNovedades.vue?vue&type=script&lang=js"
export * from "./MapaCalorNovedades.vue?vue&type=script&lang=js"
import style0 from "./MapaCalorNovedades.vue?vue&type=style&index=0&id=b1ebde18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ebde18",
  null
  
)

export default component.exports